import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import CouponBox from '../CouponBox';

import {
  makeStyles,
  Box,
  Grid,
  Typography,
} from "@material-ui/core";


const useStylesAll = makeStyles(theme => ({
  pageContainer: {
    display: "flex",
    justifyContent: "center",
  },
  container: {
    fontFamily: "Poppins",
    width: "100%",
    color: "#000000",
    padding: "10px 15px",
    [theme.breakpoints.up('md')]: {
      width: "85%",
      maxWidth: 750,
      padding: "30px",
    },
    marginTop: '50px',
  },
}));


function CouponsListPage(props) {
  const { t, i18n } = useTranslation('register');
  const classes = useStylesAll();
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [isEndSoon, setIsEndSoon] = React.useState(true); 
  const [expiry_date, setExpiry_date] = React.useState("2021/9/30"); 
  const [discount, setDiscount] = React.useState("10"); 
  
  const history = useHistory();

  function toLogin() {
    history.push("/login");
  }

  return (
    <Box className={classes.pageContainer}>
      <Box className={classes.container}>

          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h1">{t('Coupon')}</Typography>
              <Grid container 
                    spacing={3}
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center">
                    <CouponBox amount="10" validUntil="2022/12/13" expired={false} />
                    <CouponBox amount="10" validUntil="2022/12/13" expired={false} />
                    <CouponBox amount="10" validUntil="2021/01/11" expired={true} />
                    <CouponBox amount="5" validUntil="2020/10/13" expired={true} />
                    <CouponBox amount="2" validUntil="2020/10/13" expired={true} />
                  </Grid>
            </Grid>

          </Grid>
      </Box>
    </Box>
  );
}

export default CouponsListPage;
